const MockData = {
  GET: {},
  POST: {},
  PUT: {},
};

export const mock = ({ method, url, data, headers, times }) => {
  return MockData?.[method]?.[url]?.(data, headers, times) || null;
};
